const CLIENTS_ROUTE_CLIENTS_LIST = 'list';
const CLIENTS_STORE_ID = 'clients';

export { CLIENTS_ROUTE_CLIENTS_LIST, CLIENTS_STORE_ID };
